import { Pipe, PipeTransform } from '@angular/core';
import { AuthStore } from '../../core/auth/services/auth.store';

@Pipe({
  name: 'roleKey',
})
export class RoleKeyPipe implements PipeTransform {
  constructor(private authStore: AuthStore) {}
  transform(value: any, ...args: any[]): boolean {
    return this.authStore.hasRoleKey(value);
  }
}
